import React, { FC } from "react";
import { Group, Title } from "@mantine/core";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

interface PageProps {
  title?: React.ReactNode;
  documentTitle?: string;
  action?: React.ReactNode;
  children?: React.ReactNode;
}

export const Page: FC<PageProps> = (props) => {
  const { title, documentTitle, action, children } = props;

  const effectiveDocumentTitle =
    documentTitle ?? (typeof title === "string" ? title : undefined);
  useDocumentTitle(effectiveDocumentTitle);

  return (
    <>
      {(title ?? action) && (
        <Group
          justify="space-between"
          align="center"
          wrap="wrap"
          gap="xs"
          mb="md"
        >
          {title && <Title>{title}</Title>}
          {action}
        </Group>
      )}
      {children}
    </>
  );
};
